import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from '../ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    title: 'Descarga',
    desc: 'Obtienes acceso inmediato al protocolo RESET 21 en formato PDF directamente en tu correo.'
  }, {
    title: 'Activa',
    desc: 'Inicias el Método 1-2-3 y comienzas a disfrutar del plan de comidas sin gluten y lleno de sabor.'
  }, {
    title: 'Transforma',
    desc: 'Te unes a las llamadas de Zoom y ves cómo tu energía regresa y la inflamación cede en la primera semana.'
  }];
  return <section className="bg-charcoal text-cream py-24 px-6 relative overflow-hidden" data-id="element-109">
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10 pointer-events-none" data-id="element-110"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-111">
        <FadeIn className="text-center mb-16" data-id="element-112">
          <h2 className="text-4xl md:text-5xl font-serif text-copper mb-4" data-id="element-113">
            ¿Cómo funciona?
          </h2>
          <p className="text-xl text-cream/70" data-id="element-114">
            Tu camino hacia el bienestar en 3 simples pasos
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-115">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-copper/30 z-0" data-id="element-116"></div>

          {steps.map((step, idx) => <StaggerItem key={idx} className="relative z-10 flex flex-col items-center text-center" data-id="element-117">
              <div className="w-24 h-24 rounded-full bg-charcoal border-2 border-copper flex items-center justify-center text-3xl font-serif text-copper mb-6 shadow-[0_0_30px_rgba(196,149,106,0.2)]" data-id="element-118">
                {idx + 1}
              </div>
              <h3 className="text-2xl font-serif text-cream mb-4" data-id="element-119">
                {step.title}
              </h3>
              <p className="text-cream/70 leading-relaxed max-w-xs" data-id="element-120">
                {step.desc}
              </p>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}